import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import * as i0 from "@angular/core";
export class ColorPickerModule {
}
ColorPickerModule.ɵfac = function ColorPickerModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ColorPickerModule)(); };
ColorPickerModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ColorPickerModule });
ColorPickerModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, FormsModule, IconModule] });
